/* Cart section rendering provides current eligibility immediately. Fetch curated
   recommendations eagerly, keeping those fallback cards if the request fails. */
if (!customElements.get('av-cart-recommendations')) {
  customElements.define('av-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      fetch(`${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`, { signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          if (!this.isConnected || signal.aborted) return;
          const content = new DOMParser().parseFromString(text, 'text/html').querySelector('av-cart-recommendations');
          if (content) this.innerHTML = content.innerHTML;
        })
        .catch(() => {
          // The server-rendered fallback remains usable, including quick add.
        });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
